module.exports = __webpack_public_path__ + "img/newsF.2e732dc7.jpg";